import Sidebar from "../Pages/Sidebar";
import Navbar from "../Pages/Navbar";
import { Link, Route, Routes } from "react-router-dom";
import OrgDashboard from "../Pages/Organization/OrgDashboard";
import OrgMembers from "../Pages/Organization/OrgMembers";
import OrgDepartments from "../Pages/Organization/OrgDepartments";
import OrgCourses from "../Pages/Organization/OrgCourses";
import VideoPage from "../Pages/VideoPage/VideoPage";
import { useEffect } from "react";
import { getOrgDepartments } from "../store/organizationUser/organizationUser.action";
import { useDispatch, useSelector } from "react-redux";
import OrgProfile from "../Pages/Organization/OrgProfile";
import OrgSubscription from "../Pages/Organization/OrgSubscription";
import History from "../Pages/Payments/History";
import dayjs from "dayjs";

const Organization = () => {
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.loggedUser);
  const { orgProfile } = useSelector((state) => state.organization);

  useEffect(() => {
    dispatch(getOrgDepartments());
  }, [dispatch]);

  const isSubscriptionExpired = orgProfile?.subscriptionId?.status == "expired";
  const numberOfDaysLeftForSubscription = orgProfile?.subscriptionId
    ? dayjs(orgProfile?.subscriptionId?.endDate).diff(dayjs(), "day") + 1
    : Infinity;

  return (
    <div className="mainContainer d-flex w-100">
      <div className="containerLeft">
        <Sidebar />
      </div>
      <div className="containerRight w-100 ">
        <Navbar />
        {numberOfDaysLeftForSubscription < 5 ? (
          isSubscriptionExpired ? (
            <div className="py-2 px-3 border border-danger bg-danger-subtle">
              Subscription expired.
              {profile?.role === "org_owner" && (
                <>
                  {" "}
                  <Link to="/org/subscription">Click Here</Link> to renew.
                </>
              )}
            </div>
          ) : (
            <div className="py-2 px-3 border border-warning bg-warning-subtle">
              Subscription will end
              {numberOfDaysLeftForSubscription == 1
                ? ` today. `
                : ` in ${numberOfDaysLeftForSubscription} days. `}
              {profile?.role === "org_owner" && (
                <>
                  <Link to="/org/subscription">Click Here</Link> for more info.
                </>
              )}
            </div>
          )
        ) : null}
        <div className="mainAdmin ml-4">
          <div className="mobSidebar-bg  d-none"></div>
          <Routes>
            <Route path="/dashboard" element={<OrgDashboard />} />
            <Route path="/members" element={<OrgMembers />} />
            <Route path="/departments" element={<OrgDepartments />} />
            <Route path="/videos" element={<VideoPage />} />
            <Route path="/courses" element={<OrgCourses />} />
            <Route path="/profile" element={<OrgProfile />} />
            <Route path="/subscription" element={<OrgSubscription />} />
            <Route path="/payments" element={<History />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default Organization;
